<script>
  import { Photo } from '@st-graphics/graphics-components'
  import { md } from '@st-graphics/graphics-kit/utils'
  import Scroller from '@sveltejs/svelte-scroller'

  import BTOBackground from './BTOBackground.svelte'
  import BodyWordCloudCanvas from './BodyWordCloudCanvas.svelte'
  import Beeswarm from './Beeswarm/Beeswarm.svelte'
  import Search from './Search/Search.svelte'
  import { sheetJson } from '$state/data'
  import WordCloudCanvas from '../WordCloud/WordCloudCanvas.svelte'

  let {
    value,
    //cardsalign = 'center', // left, center, right
    top = 0,
    bottom = 0,
    threshold = 1,
    count = $bindable(0),
    index = $bindable(0),
    offset = $bindable(0),
    progress = $bindable(0),
    cloudMode = 'cloud',
    cloudActiveCategory = null,
    cloudActiveWords = null,
  } = $props()

  let cardsalign = $derived(index < 6 ? 'left' : 'center')

  const cards = $derived(value.cards || [])

  //const beeswarmData = $derived(
  //  sheetJson.data.filter(
  //    (d) =>
  //      (d.Probability_BTO !== undefined && d.Probability_BTO !== '') ||
  //      (d.Probability_Condo !== undefined && d.Probability_Condo !== ''),
  //  ),
  //)

  let query = $state('')
  let suggestions = $state([])

  $effect(() => {
    if (index !== 7) {
      query = ''
      suggestions = []
    }
  })
</script>

<Scroller
  {top}
  {bottom}
  {threshold}
  bind:count
  bind:index
  bind:offset
  bind:progress
  query=".scrolly-card"
>
  {#snippet background()}
    <div class="scrolly-background">
      <div class="sr-only" aria-live="assertive">
        Scrolly background updated for slide {index + 1}.
      </div>

      <!--<div
        class="debug"
        style="position:absolute; top:0; left:0; z-index:10; font-size: 14px; z-index: 999;"
      >
        card:{index} | {offset.toFixed(2)}<br />
      </div>-->

      {#if index <= 3}
        <BTOBackground {index} {offset} />
      {/if}
      {#if index >= 2}
        <BodyWordCloudCanvas
          {index}
          {offset}
          mode={cloudMode}
          activeCategory={cloudActiveCategory}
          activeWords={cloudActiveWords}
        />
      {/if}
      {#if index >= 4}
        <Beeswarm {index} {offset} bind:query bind:suggestions lastCardText={cards[9].text} />
      {/if}
    </div>
  {/snippet}

  {#snippet foreground()}
    <div class="scrolly-foreground">
      <div class="cards-container {cardsalign}">
        {#each cards as { text, thumbnail, alt, classname = undefined, lazy = false }, i (i)}
          <div
            class="scrolly-section scrolly-card {classname}"
            class:hide={i === 9}
            class:blank={text.length < 1}
            role={text.length >= 1 ? 'group' : undefined}
            aria-label={text.length >= 1 ? `Slide ${i + 1}` : undefined}
          >
            <p class="scrolly-text">{@html md(text)}</p>
            <!--{#if i === 8}
              <div class="searchbox">
                <Search data={beeswarmData} bind:query bind:suggestions />
              </div>
            {/if}-->
          </div>
        {/each}
      </div>
    </div>
  {/snippet}
</Scroller>

<style lang="scss">
  .scrolly-background {
    position: relative;
    height: 100vh;
    min-height: 100vh;
    contain: layout paint;
    overflow: hidden;
    will-change: transform;
    background: var(
      --scrolly-background-background,
      var(--theme-scrolly-background-background, transparent)
    );
  }

  /* ── Foreground ── */
  .scrolly-foreground {
    display: flex;
    flex-direction: column;
    align-items: var(--scrolly-foreground-align-items, center);
    padding: 0 1rem;
    margin: 0 auto;
    transform: translateZ(0);
    pointer-events: none;
  }
  .scrolly-foreground .header-card {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100vh;
  }
  .scrolly-foreground .header-card.start {
    margin-top: -100vh;
  }
  .scrolly-foreground .cards-container {
    display: flex;
    flex-direction: column;
    align-items: var(--md-scrolly-foreground-align-items, start);
    width: 100%;
    max-width: 75rem;
    padding-bottom: max(50rem, 100vh);
    margin: 0 auto;
  }
  .scrolly-foreground .cards-container.left {
    align-items: flex-start;
  }
  .scrolly-foreground .cards-container.center {
    align-items: center;
  }
  .scrolly-foreground .cards-container.right {
    align-items: flex-end;
  }
  .scrolly-foreground .cards-container .scrolly-section {
    margin-bottom: max(50rem, 100vh);
  }
  .scrolly-foreground .cards-container .scrolly-card {
    width: 100%;
    max-width: var(--scrolly-card-max-width, 25rem);
    font-size: var(--scrolly-card-font-size, 1.25rem);
    line-height: var(--scrolly-card-line-height, 1.9375rem);
    text-align: var(--scrolly-card-text-align, unset);
    color: var(--scrolly-card-color, var(--theme-scrolly-card-color, var(--st-black)));
    background: var(
      --scrolly-card-background,
      var(--theme-scrolly-card-background, var(--st-white))
    );
    pointer-events: auto;
    border: solid 1px #fff;

    &.hide {
      opacity: 0;
      pointer-events: none;
    }
  }
  .scrolly-foreground .cards-container .scrolly-card .scrolly-text {
    padding: var(--scrolly-text-padding, 0.9375rem 0.9375rem 1.25rem);
    border: none;
  }
  .scrolly-foreground .cards-container .scrolly-card .scrolly-text:only-child {
    padding-top: 0.9375rem;
  }
  .scrolly-foreground .cards-container .scrolly-card:last-child {
    margin-bottom: 0;
  }
  .scrolly-foreground .cards-container .scrolly-card.blank {
    opacity: 0;
  }
  .scrolly-foreground .cards-container .scrolly-card .searchbox {
    margin: 0 0.9375rem 1.25rem;
    pointer-events: auto;
  }
  @media (width >= 744px) {
    .scrolly-foreground .cards-container .scrolly-card {
      margin: 0 0.625rem max(50rem, 100vh);
      font-size: 1.375rem;
    }
  }

  :global(svelte-scroller-background-container) {
    position: sticky !important;
    transform: translate(0, 0) !important;
  }

  :global(svelte-scroller-foreground) {
    pointer-events: none !important;
  }

  //:global([data-theme='dark']) .scrolly-card {
  //  --theme-scrolly-card-color: var(--st-white-primary);
  //  --theme-scrolly-card-background: rgb(0 0 0 / 60%);
  //}
</style>
